import React, { useContext, useEffect, useState } from "react";
import { getCrewRoleList } from "../../../api/crew/crewRole";
import { useIsMounted } from "../../../utils/hooks";
import { VesselContext } from "../../../routes/vessel/VesselRoot";
import { Select, Option } from "../../form/Select";
import { Word } from "../../lang/Word";

export const CrewRoleSelect = ({ value, onChange }) => {
    const { vessel } = useContext(VesselContext);
    const [crewRoleList, setCrewRoleList] = useState(null);
    const [busyLoading, setBusyLoading] = useState(false);
    const isMountedRef = useIsMounted();

    useEffect(() => {
        setBusyLoading(true);
        getCrewRoleList()
            .then((response) => {
                if (isMountedRef.current) {
                    setCrewRoleList(response);
                }
            })
            .finally(() => {
                setBusyLoading(false);
            });
    }, [vessel.id, isMountedRef]);

    return (
        <Select
            value={value}
            disabled={busyLoading}
            onChange={(value) => onChange(crewRoleList.find((r) => r.key === value))}
        >
            {crewRoleList?.map((role) => (
                <Option key={role.key} value={role.key}>
                    <Word data={role.name} />
                </Option>
            ))}
        </Select>
    );
};
